<template>
    <div id="doomClock" :class="{ collapsed }">

        <div class="lifeline-container" :class="{ collapsed: collapsed }">
            <!-- Left Minute Box -->
            <div
                class="doomclock-box"
                :style="{ backgroundColor: currentColor }"
                @click="toggleCollapse"
            >
                {{ minutes }}m
            </div>

            <!-- Minute Circles -->
            <div
                class="minutes d-flex flex-wrap justify-content-center"
                :class="{ collapsed: collapsed }"
            >
                <div
                    v-for="i in 15"
                    :key="'minute-' + i"
                    class="minute-circle minute-circle1"
                    :class="{ filled: i <= minutes }"
                    @click="setMinutes(i)"
                    :title="`Minute ${i}`"
                ></div>

                <div
                    v-for="i in 15"
                    :key="'minute-' + (i + 15)"
                    class="minute-circle minute-circle2"
                    :class="{ filled: i + 15 <= minutes }"
                    @click="setMinutes(i + 15)"
                    :title="`Minute ${i + 15}`"
                ></div>

                <div
                    v-for="i in 15"
                    :key="'minute-' + (i + 30)"
                    class="minute-circle minute-circle3"
                    :class="{ filled: i + 30 <= minutes }"
                    @click="setMinutes(i + 30)"
                    :title="`Minute ${i + 30}`"
                ></div>

                <div
                    v-for="i in 15"
                    :key="'minute-' + (i + 45)"
                    class="minute-circle minute-circle4"
                    :class="{ filled: i + 45 <= minutes }"
                    @click="setMinutes(i + 45)"
                    :title="`Minute ${i + 45}`"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DoomclockTracker",
    props: {
        initial: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            minutes: this.initial,
            lastClickedCounter: null,
            collapsed: true, // New state for collapsing
        };
    },
    computed: {
        currentColor() {
            if (this.minutes >= 45) return "rgba(255, 65, 54, 0.7)"; // red
            if (this.minutes >= 30) return "rgba(253, 161, 31, 0.7)"; // orange
            if (this.minutes >= 15) return "rgba(255, 232, 54, 0.7)"; // yellow
            return "rgba(94, 255, 54, 0.7)"; // green
        },
    },
    methods: {
        setMinutes(count) {
            if (this.lastClickedCounter === count) {
                this.minutes = count - 1;
                this.lastClickedCounter = null;
            } else {
                this.minutes = count;
                this.lastClickedCounter = count;
            }
            this.$emit("update", this.minutes);
        },
        toggleCollapse() {
            this.collapsed = !this.collapsed; // Toggle the collapsed state
        },
    },
};
</script>

<style scoped>
/* --- DOOMCLOCK (fixed overlay) --- */
#doomClock {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1030;
    width: 100%;
    /* default pointer-events: auto - if the Doomclock blocks interaction with content you can change it */
}
/* when collapsed, the fixed wrapper should not intercept clicks */
#doomClock.collapsed {
  pointer-events: none;     /* allow clicking what's behind */
  z-index: 0;               /* optional: drop it under other UI */
}

/* but the expand handle (left box) must still be clickable */
#doomClock.collapsed .doomclock-box {
  pointer-events: auto;
  z-index: 1;               /* ensure above the page just enough to receive clicks */
}

/* optionally shrink the interactive footprint to just the handle */
.lifeline-container.collapsed .minutes {
  display: none;            /* remove from layout/hit-testing */
}

.lifeline-container {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    padding: 0; /* remove padding so box reaches edges */
    align-items: stretch;
}
.lifeline-container.collapsed {
    pointer-events: none; /* let clicks go through */
}

.lifeline-container .doomclock-box {
    pointer-events: auto; /* still clickable to expand */
}

/* Left box flush to top/bottom/left */
.doomclock-box {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.2rem;
    color: #000;
    transition: background-color 0.3s;
    border-top-right-radius: 10px; /* round top right corner */
    border-bottom-right-radius: 10px; /* round bottom right corner */
    cursor: pointer; /* Add pointer cursor */
}

/* Shift circles to the right of the box with small gap */
.minutes {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    justify-content: center; /* center horizontally */
    align-items: center;
    padding: 1rem 1rem 1rem 4rem;
    transition: margin-left 0.3s, opacity 0.3s; /* Smooth transition */
    background-color: rgba(0, 0, 0, 0.6);
}

.minutes.collapsed {
    margin-left: 0; /* Shrink to the left */
    opacity: 0; /* Fade out */
    pointer-events: none; /* Disable interaction */
}

/* Minute Circles */
.minute-circle {
    width: 20px;
    height: 24px;
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
}

.minute-circle1 {
    border: 2px solid #5eff36;
}
.minute-circle1.filled {
    background: #5eff36;
    border-color: #5eff36;
}

.minute-circle2 {
    border: 2px solid #ffe836;
}
.minute-circle2.filled {
    background: #ffe836;
    border-color: #ffe836;
}

.minute-circle3 {
    border: 2px solid #fda11f;
}
.minute-circle3.filled {
    background: #fda11f;
    border-color: #fda11f;
}

.minute-circle4 {
    border: 2px solid #ff4136;
}
.minute-circle4.filled {
    background: #ff4136;
    border-color: #ff4136;
}
</style>

